import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl, headersDefault } from ".";
import { fetchJsonRead } from "../../services/readRequest";

export const getCoinBalance = createAsyncThunk(
  "coins/getBalance",
  async () => {
    return await fetchJsonRead(`${baseUrl}/api/app/coins/balance`, {
      headers: headersDefault(),
    });
  }
);

export const getCoinActions = createAsyncThunk(
  "coins/getActions",
  async () => {
    return await fetchJsonRead(`${baseUrl}/api/app/coins/actions`, {
      headers: headersDefault(),
    });
  }
);

export const getCoinHistory = createAsyncThunk(
  "coins/getHistory",
  async ({ type, page = 1, append = false } = {}) => {
    const params = new URLSearchParams();
    if (type) params.append("type", type);
    if (page) params.append("page", page);

    const url = `${baseUrl}/api/app/coins/history${
      params.toString() ? `?${params.toString()}` : ""
    }`;

    const data = await fetchJsonRead(url, {
      headers: headersDefault(),
    });
    return { ...data, append, type, page };
  }
);

/**
 * Credits today's "Accesso giornaliero" bonus if it is still owed, and reports
 * it either way. Called once per cold start so the daily-bonus popup can show.
 *
 * POST because it awards: the backend's AwardDailyLoginBonus middleware credits
 * in terminate(), i.e. after a response has already been flushed, so a
 * read-only call made as the app's first request would report "nothing" for a
 * bonus granted a moment later. The endpoint therefore awards (idempotently)
 * and then reports. The coins land regardless of what the popup does.
 */
export const claimDailyBonus = createAsyncThunk(
  "coins/claimDailyBonus",
  async () => {
    const response = await fetch(`${baseUrl}/api/v1/me/daily-bonus`, {
      method: "POST",
      headers: headersDefault(),
    });

    if (!response.ok) throw new Error("dailyBonusFailed");

    return await response.json();
  },
);
